import { computed, makeAutoObservable } from "mobx";
import { SaveStoreApi } from "./API/SaveStore";
import AccessServerClient from "../ServerClients/AccessServerClient";
import { ChangeEvent } from "react";
import {
  AccessPropApi,
  ObservableAccessPropImpl,
  StartAccessData,
} from "../DTO/Access";

export class AccessStore implements SaveStoreApi {
  public accessData: ObservableAccessPropImpl = new ObservableAccessPropImpl(
    new StartAccessData()
  );
  public withNavigationAfterSaving: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setAccessData = (accessData: AccessPropApi): void => {
    this.accessData = new ObservableAccessPropImpl(accessData);
  };

  onChangeUserMail = (event: ChangeEvent<HTMLInputElement>): void => {
    this.accessData.onChangeUserMail(event.currentTarget.value);
  };
  onChangeLearningPath = (event: ChangeEvent<HTMLSelectElement>): void => {
    this.accessData.onChangeLearningPathId(event.currentTarget.value);
  };
  onChangeNumGroups = (event: ChangeEvent<HTMLInputElement>): void => {
    this.accessData.onChangeNumGroups(parseInt(event.currentTarget.value));
  };
  onChangeNumStudents = (event: ChangeEvent<HTMLInputElement>): void => {
    this.accessData.onChangeNumStudentsInGroup(
      parseInt(event.currentTarget.value)
    );
  };
  onChangeTime = (event: ChangeEvent<HTMLInputElement>): void => {
    this.accessData.onChangeAccessTimeInMonths(
      parseInt(event.currentTarget.value)
    );
  };

  @computed get saveWindowTitle(): string {
    return "Создание промокода";
  }

  @computed get saveClickAsync(): Promise<null> {
    return AccessServerClient.sendToCreateAccessAsync(this);
  }

  @computed get saveButtonText(): string {
    return "Создать промокод";
  }

  setId = (id: string): void => {
    this.accessData.accessId = id;
  };
}
